import { useEffect, useMemo, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

import { ThemeProvider, createTheme } from "@mui/material/styles";

import useThemeMode from "src/Theme/useThemeMode";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs from "dayjs";

import BlueButton from "src/Components/Common/bluebutton";
import CancelButton from "src/Components/Common/cancelbutton";

const DatePickerModal = ({ shown, cancelClicked, dateSelected, pSelectedDate, timeVisible = true }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  // MUI keeps its own palette, so no CSS token reaches inside the picker — in
  // dark mode it kept rendering near-black text (rgba(0,0,0,0.87)) on a dark
  // surface. Giving it a matching MUI theme fixes every date picker at once;
  // this modal backs all six date fields in the app.
  const mode = useThemeMode();
  const muiTheme = useMemo(
    () =>
      createTheme({
        palette:
          mode === "dark"
            ? {
                mode: "dark",
                primary: { main: "#529be2" },
                background: { paper: "#1b2a44", default: "#131f33" },
                text: { primary: "#f6f8fa", secondary: "#d3d9e0" },
                divider: "#607bad",
              }
            : { mode: "light" },
      }),
    [mode]
  );

  useEffect(() => {
    if (pSelectedDate) {
      setSelectedDate(Date.parse(pSelectedDate));
    } else {
      setSelectedDate(new Date());
    }
  }, [pSelectedDate]);

  return (
    shown && (
      <OutsideClickHandler onOutsideClick={cancelClicked}>
        <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="bg-white rounded-md ">
            <ThemeProvider theme={muiTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {timeVisible ? (
                <StaticDateTimePicker
                  orientation="landscape"
                  value={dayjs(selectedDate)}
                  onChange={(newValue) => {
                    console.log(newValue, typeof newValue);
                    setSelectedDate(newValue);
                  }}
                  onAccept={() => dateSelected(selectedDate)}
                  onClose={() => cancelClicked()}
                />
              ) : (
                <StaticDatePicker
                  orientation="landscape"
                  value={dayjs(selectedDate)}
                  onChange={(newValue) => {
                    console.log(newValue, typeof newValue);
                    setSelectedDate(newValue);
                  }}
                  onAccept={() => dateSelected(selectedDate)}
                  onClose={() => cancelClicked()}
                />
              )}
            </LocalizationProvider>
            </ThemeProvider>

            {/* <DateTimePicker /> */}

            {/* <DatePicker
              isOpen={true}
              // onClose={() => setIsDatePickerOpen(false)}
              // defaultValue={new Date()}
              // minDate={new Date()}
              selected={selectedDate}
              // headerFormat="DD, MM dd"
              dateFormat="dd/MM/yyyy h:mm aa"
              onChange={(date) => {
                setSelectedDate(date);
                console.log("selected date: ", date);
              }}
              colorScheme="#010D3D"
              showTimeInput
              inline
            /> */}
            {/* <div className="flex items-center justify-between">
              <CancelButton onClicked={cancelClicked} />
              <BlueButton
                title="Save"
                onClicked={() => dateSelected(selectedDate)}
              />
            </div> */}
          </div>
        </div>
      </OutsideClickHandler>
    )
  );
};

export default DatePickerModal;
